/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowbrandcoloradd4Inputs */

const en_aiflowbrandcoloradd4 = /** @type {(inputs: Aiflowbrandcoloradd4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add colour`)
};

const de_aiflowbrandcoloradd4 = /** @type {(inputs: Aiflowbrandcoloradd4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farbe hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add colour" |
*
* @param {Aiflowbrandcoloradd4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowbrandcoloradd4 = /** @type {((inputs?: Aiflowbrandcoloradd4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowbrandcoloradd4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowbrandcoloradd4(inputs)
	return de_aiflowbrandcoloradd4(inputs)
});
export { aiflowbrandcoloradd4 as "aiFlowBrandColorAdd" }